import { useParams, useRouteLoaderData } from "react-router";
import KlientkontoerklaeringForm from "../../components/klientkontoerklaering/KlientkontoerklaeringForm";
import AppShellContent from "@/layouts/AppShellContent";
import { reviver } from "../../util/json";
import { KlientkontoerklaeringMetadata } from "../../interfaces/klientkontoerklaering";
import { KKE_FORM_INITIAL_VALUES } from "../../constants/klientkontoerklaering/initialValues";
import { KlientkontoErklaering } from "../../interfaces/api";
import { ROUTES } from "../../constants/routes";
import Redirect from "../../components/Redirect";
import { defaultApiUrl } from "../../api/util";
import PageError from "../PageError";

export const TokenRedirect = () => {
  const { token } = useParams();
  return (
    <Redirect
      to={`${defaultApiUrl}/Authentication/LoginToken`}
      params={`loginToken=${token}`}
    />
  );
};

export default function TokenKlientkontoerklaering() {
  const data = useRouteLoaderData(ROUTES.linkToken.id) as {
    klientkontoerklaering: KlientkontoErklaering;
    metadata: KlientkontoerklaeringMetadata;
  };
  const jsonData = data.klientkontoerklaering.jsonData;
  const check = !!jsonData && jsonData !== "null";
  const formValues =
    check && data.klientkontoerklaering.formularType === "Formular1"
      ? JSON.parse(jsonData, reviver)["form"]
      : KKE_FORM_INITIAL_VALUES;

  if (data.klientkontoerklaering.status !== "Kladde") {
    return (
      <PageError
        msg={`Erklæringen er ${data.klientkontoerklaering.status.toLowerCase()}`}
      />
    );
  }

  return (
    <AppShellContent>
      <div className="container-xxl mt-3 mb-7">
        <KlientkontoerklaeringForm
          id={data.klientkontoerklaering.id}
          kke={data.klientkontoerklaering}
          initialValues={formValues ? formValues : KKE_FORM_INITIAL_VALUES}
          metadata={data.metadata}
          formularType="Formular1"
        />
      </div>
    </AppShellContent>
  );
}
